import { render } from "./Helpdesk.vue?vue&type=template&id=311c6b22"
import script from "./Helpdesk.vue?vue&type=script&lang=js"
export * from "./Helpdesk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__